.orderList {
  display: var(--haus-orderHistory__orderList__display, flex);
  flex-direction: var(--haus-orderHistory__orderList__flex-direction, column);
  align-items: var(--haus-orderHistory__orderList__align-items, flex-start);
  gap: var(--haus-orderHistory__orderList__gap, 1rem);
  padding: var(--haus-orderHistory__orderList__padding, 2rem);
  overflow-x: var(--haus-orderHistory__orderList__overflow-x, auto);
  background: var(--haus-orderHistory__orderList__background, #fff);
}

.orderListContent {
  display: var(--haus-orderHistory__orderListContent__display, flex);
  flex-direction: var(--haus-orderHistory__orderListContent__flex-direction, column);
  width: var(--haus-orderHistory__orderListContent__width, 100%);
}

.error {
  display: var(--haus-orderHistory__error__display, flex);
  justify-content: var(--haus-orderHistory__error__justify-content, center);
  align-items: var(--haus-orderHistory__error__align-items, center);
  padding: var(--haus-orderHistory__error__padding, 1rem);
}
